<div class="abc-referral-popup-custom">
  <!-- Mobile Drag Handle -->
  <div class="mobile-drag-handle"></div>

  <!-- Floating Close Button -->
  <button class="close-btn-float" (click)="closeModal()" aria-label="Close">&times;</button>

  <div class="content-wrapper">
    <!-- Glowing Gift Icon -->
    <div class="gift-icon-glow">
      <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
        <path
          d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z" />
      </svg>
    </div>

    <!-- Premium Headline -->
    <h2>{{ "nav.Invite your friend" | translate }}</h2>
    <p>{{ "nav.Share Code" | translate }}</p>

    <!-- Ticket Style Code Container -->
    <div class="referral-ticket">
      <input type="text" class="code-display" [value]="referral.referralCode" readonly aria-label="Referral Code" />
      <button class="action-btn" [disabled]="copied" (click)="copyReferralCode()">
        {{ copied ? ("nav.Copied" | translate) : ("nav.Copy" | translate) }}
      </button>
    </div>

    <!-- Divider -->
    <div class="separator">
      <span>SHARE VIA</span>
    </div>

    <!-- Social Buttons -->
    <div class="share-buttons">
      <share-buttons [include]="sharingPlatforms" [url]="sharingURL" theme="circles-dark" showText="false"
        (opened)="shareLog($event)" [title]="referral.title ?? 'Unlock Exclusive Reward with My Referral Code!'"
        [description]="referral.content ?? ''" show="5" size="0">
      </share-buttons>
    </div>
  </div>
</div>